import { render, staticRenderFns } from "./ContactPhoneIcon.vue?vue&type=template&id=12fa008e&scoped=true&"
import script from "./ContactPhoneIcon.vue?vue&type=script&lang=js&"
export * from "./ContactPhoneIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContactPhoneIcon.vue?vue&type=style&index=0&id=12fa008e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa008e",
  null
  
)

export default component.exports